<div>
    <div class="dialog_content">

        <div class="form_row" style="align-items: center">

            <div class="form_row_item" *ngIf="movtype == TipoMovimentazione.MAGAZZINO_MAGAZZINO || movtype == TipoMovimentazione.TIM_IMPRESA">
                Destinazione: {{ movref.destinazione.codice }}
<!--                <input type="text" pInputText [disabled]="true" [value]="movref.destinazione.codice"/>-->
            </div>

            <div class="form_row_item">
                <p-calendar styleClass="calendargroup" [ariaLabel]="'Data'" [maxDate]="max_date" [minDate]="min_date" appendTo="body" [showOnFocus]="false" [showIcon]="true" [(ngModel)]="action_date" (change)="verifyForm()"></p-calendar>
            </div>

            <div style="flex-grow: 1">
            </div>
            <div>
                  <p-button *ngIf="direction_delivery" icon="pi pi-exclamation-triangle" [label]="this.discrepanza == null ? 'Segnala discrepanza' : 'Modifica discrepanza'" class="p-button-text ml-100 row_button" (click)="openDiscrepanzaDialog()" ></p-button>
            </div>

            <div>

            </div>
        </div>

        <div class="form_row field">
            <!--            <textarea id="field_indirizzo" style="width: 100%" rows="2" type="text" pInputTextarea [(ngModel)]="edits.indirizzo" (input)="verifyEditsValidity()" placeholder="Indirizzo"></textarea>-->
        </div>

        <div class="form_row field">
            <p-table style="width: 100%" [value]="movref.materiali" >
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="id">
                            <div class="flex justify-content-between align-items-center">
                                NMU
                            </div>
                        </th>
                        <th pSortableColumn="tipo">
                            <div class="flex justify-content-between align-items-center">
                                Marca
                            </div>
                        </th>
                        <th pSortableColumn="tipo">
                            <div class="flex justify-content-between align-items-center">
                                Descrizione
                            </div>
                        </th>
                        <th>
                            <div class="flex justify-content-between align-items-center" [ngSwitch]="discrepanza==null">
                                <span *ngSwitchCase="true">Quantità</span>
                                <span *ngSwitchCase="false">Previsti</span>
                            </div>
                        </th>
                        <th *ngIf="discrepanza != null">
                            Effettivi
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td><span class="text-lowercase">{{ row.info.nmu }}</span></td>
                        <td><span class="text-lowercase">{{ row.info.marca }}</span></td>
                        <td><span class="text-lowercase">{{ row.info.descrizione }}</span></td>
                        <td><span class="text-lowercase">{{ row.qt }}</span></td>
                        <td *ngIf="this.discrepanza != null"><span class="text-lowercase">{{ row.qt + (this.discrepanza[row.info.id] ?? 0) }}</span></td>
                    </tr>
                </ng-template>
                <!--            <textarea id="field_referente" style="width: 100%" rows="3" type="text" pInputTextarea [(ngModel)]="edits.referente" (input)="verifyEditsValidity()" placeholder="Referente"></textarea>-->
            </p-table>
        </div>


    </div>

    <p-divider type="solid"></p-divider>

    <div class="dialog_controls">

        <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
        <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" [disabled]="!hasValidForm"></p-button>
    </div>
</div>